import { queryOptions } from '@tanstack/react-query';
import type { AdminCityDto } from '@upme/contracts';
import { api } from '../../app/api-client';

export const citiesKey = ['admin', 'cities'] as const;

// admin/cities отдаёт AdminCityDto (ADMIN_CITY_SELECT): CityDto + бейдж трансляции (#146).
export const listCitiesOptions = () =>
  queryOptions({
    queryKey: [...citiesKey],
    queryFn: () => api.get('admin/cities').json<AdminCityDto[]>(),
    staleTime: 30_000,
  });

export const cityByIdOptions = (id: string) =>
  queryOptions({
    queryKey: [...citiesKey, id],
    queryFn: () => api.get(`admin/cities/${id}`).json<AdminCityDto>(),
  });
